import { ceres_api } from "@/axios-config.js"

const Content = {
    getPage(page) {
        return ceres_api.get("/content/get_page/" + page)
    }
}

export default Content
